import { render } from "./TariffsNew.vue?vue&type=template&id=16e0baa0&scoped=true"
import script from "./TariffsNew.vue?vue&type=script&lang=js"
export * from "./TariffsNew.vue?vue&type=script&lang=js"

import "./TariffsNew.vue?vue&type=style&index=0&id=16e0baa0&scoped=true&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e0baa0"]])

export default __exports__